import {Map} from 'immutable'
import Firebase from 'firebase'
import firedux from '../firedux'

import {
  NOTIFICATIONS_ENDPOINT
} from '../../config/constants'

export default (type, notificationData) => {
  if (!type || !notificationData) return Promise.resolve()

  const ENDPOINT = `${NOTIFICATIONS_ENDPOINT}/${type}`

  const notification = Map({time: Firebase.ServerValue.TIMESTAMP}).merge(notificationData).toJS()

  return firedux.ref.child(ENDPOINT).push(notification)
}



/** WEBPACK FOOTER **
 ** ./modules/shared/data/setters/send_notification.js
 **/